export default __webpack_public_path__ + "static/media/Menu.238ba66c.svg";